module.exports = __webpack_public_path__ + "img/locate.4f2765cb.png";